/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Total_NoteInputs */



/**
* | output |
* | --- |
* | "Net, with your partner discount already applied" |
*
* @param {Partner_Billing_Total_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_total_note = /** @type {((inputs?: Partner_Billing_Total_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Total_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Netto, Ihr Partnerrabatt ist bereits abgezogen")
	return /** @type {LocalizedString} */ ("Net, with your partner discount already applied")
});